import {css} from "@emotion/react";

export const imageResponsive = css`
    display: block;
    max-width: 100%;
    height: auto;
`;
import {css} from "@emotion/react";

export const imageResponsive = css`
    display: block;
    max-width: 100%;
    height: auto;
`;
